import { type FC } from "react";

import { useAnchorPosition } from "./hooks/use-anchor-position.ts";
import { useGroupHeight } from "./hooks/use-group-height.ts";
import { SVG_STYLES } from "./settings.ts";

interface AnchorPointProps {
  groupId: string;
  scale: number;
}

export const AnchorPoint: FC<AnchorPointProps> = ({ groupId, scale }) => {
  const x = useAnchorPosition(groupId, scale);
  const height = useGroupHeight();
  return (
    x != undefined && (
      <rect
        x={x}
        y={SVG_STYLES.group.strokeWidth}
        {...SVG_STYLES.anchorPoint}
        height={height - SVG_STYLES.group.strokeWidth}
      />
    )
  );
};
